import { GENERIC_ERROR_MESSAGE } from '@shared/constants/errors';

export default class InternalServerError extends Error {
  constructor(message = GENERIC_ERROR_MESSAGE) {
    super(message);
    this.name = 'InternalServerError';
  }
}
